export default __webpack_public_path__ + "static/media/Gloves of Red Ruin (nm).231ab819.jpg";